import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Nav() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path;
    };

    const navLinks = [
        { path: '/about', label: 'About' },
        { path: '/races', label: 'Races' },
        { path: '/community', label: 'Community' }
    ];

    return (
        <nav className="bg-gray-900 fixed w-full z-50 border-b border-sky-400/20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo and Brand */}
                    <div className="flex-shrink-0">
                        <Link to="/" className="hover:opacity-80 transition-opacity duration-200">
                            <img 
                                src="/img/BirdOutline.png" 
                                alt="Osprey Racing" 
                                className="h-8 w-auto"
                            />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:block">
                        <div className="ml-10 flex items-baseline space-x-4">
                            {navLinks.map(({ path, label }) => (
                                <Link
                                    key={path}
                                    to={path}
                                    className={`relative px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 flex flex-col items-center ${
                                        isActive(path)
                                            ? 'text-sky-400'
                                            : 'text-gray-300 hover:text-sky-400'
                                    }`}
                                >
                                    {label}
                                    {/* Animated underline for active link */}
                                    <span
                                        className={`absolute left-0 right-0 -bottom-1 h-0.5 rounded bg-sky-400 transition-all duration-300 ${
                                            isActive(path) ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
                                        }`}
                                        style={{ transformOrigin: 'center' }}
                                    />
                                </Link>
                            ))}
                        </div>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsOpen(!isOpen)}
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-sky-400 hover:bg-sky-400/20 focus:outline-none"
                        >
                            <span className="sr-only">Open main menu</span>
                            {!isOpen ? (
                                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                            ) : (
                                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation */}
            <div className={`md:hidden ${isOpen ? 'block' : 'hidden'} bg-gray-900 border-b border-sky-400/20`}>
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                    {navLinks.map(({ path, label }) => (
                        <Link
                            key={path}
                            to={path}
                            className={`block px-3 py-2 rounded-md text-base font-medium ${
                                isActive(path)
                                    ? 'bg-sky-400 text-gray-900'
                                    : 'text-gray-300 hover:bg-sky-400/20 hover:text-sky-400'
                            }`}
                            onClick={() => setIsOpen(false)}
                        >
                            {label}
                        </Link>
                    ))}
                </div>
            </div>
        </nav>
    );
}

